var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", fixed: "", color: "rgb(170, 210, 95)", dark: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function(ref) {
              var on = ref.on
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    { attrs: { icon: "", dark: "" }, on: { click: _vm.click } },
                    on
                  ),
                  [_c("v-icon", [_vm._t("default")], 2)],
                  1
                )
              ]
            }
          }
        ],
        null,
        true
      )
    },
    [_c("span", [_vm._v(_vm._s(_vm.title))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }